import React from 'react';
import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { Body1 } from '../../blocks';

const RemoveEmailModal = ({ deleteModal, setDeleteModal, loading, onConfirm }) => {
    const close = () => setDeleteModal(null);

    return (
        <NavResponsiveModal open={!!deleteModal} onClose={close}>
            <ModalHeader title="Remove this email address?" onClose={close} />
            <ModalContent>
                {/* No count here on purpose: the address is unsubscribed from every row the server
                    holds, which can include communications the picker does not display, so any
                    number shown would contradict the card above. */}
                <Body1>{deleteModal?.email} will be unsubscribed from all of its notifications.</Body1>
            </ModalContent>
            <ModalActions>
                <SecondaryButton onClick={close}>Cancel</SecondaryButton>
                <PrimaryButton onClick={() => onConfirm(deleteModal)} disabled={loading}>
                    Delete
                </PrimaryButton>
            </ModalActions>
        </NavResponsiveModal>
    );
};

export default RemoveEmailModal;
